import { createSlice } from "@reduxjs/toolkit";

const calendarSlice = createSlice({
  name: "calendar",
  initialState: {
    list: [],
    employeeId: null,
  },
  reducers: {
    setList(state, action) {
      state.list = action.payload;
    },
    setEmployeeId(state, action) {
      state.employeeId = action.payload;
    },
  },
});

export const { setList, setEmployeeId } = calendarSlice.actions;
export default calendarSlice.reducer;
